module.exports = __webpack_public_path__ + "img/houndstooth.00850d4e.jpg";